import CreateNewOrderContainer from './create-new-order-container';

export default CreateNewOrderContainer;
